/**
 * Saves a PDF blob to disk. When preferDownload is true (e.g. batch save),
 * downloads to user's Downloads folder without dialogs.
 * @param {Blob} blob - The PDF blob to save
 * @param {string} filename - Suggested filename
 * @param {{ preferDownload?: boolean }} options - preferDownload: skip picker, use download
 * @returns {Promise<void>}
 */
export const savePdfToDisk = async (blob, filename, options = {}) => {
	if (typeof window === "undefined") return;
	const { preferDownload = false } = options;
	if (preferDownload || !window.showSaveFilePicker) {
		fallbackDownload(blob, filename);
		return;
	}
	try {
		const handle = await window.showSaveFilePicker({
			suggestedName: filename,
			types: [{ description: "PDF", accept: { "application/pdf": [".pdf"] } }],
		});
		const writable = await handle.createWritable();
		await writable.write(blob);
		await writable.close();
	} catch (err) {
		if (err.name === "AbortError") return;
		fallbackDownload(blob, filename);
	}
};

const fallbackDownload = (blob, filename) => {
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
};
